import api from "./apiBase";

export const getPublicMakerLink = async (identifier) => {
  return api.get(`/link/${encodeURIComponent(identifier)}`);
};

export const trackPublicMakerLinkEvent = async (identifier, payload) => {
  return api.post(`/link/${encodeURIComponent(identifier)}/events`, payload);
};

export const getMyLinkProfiles = async (params = {}) => {
  return api.get("/link-profiles/me", { params });
};

export const requestClaimCode = async (identifier) => {
  return api.post(`/link/${encodeURIComponent(identifier)}/claim/request-code`);
};

export const verifyClaimCode = async (identifier, code) => {
  return api.post(`/link/${encodeURIComponent(identifier)}/claim/verify-code`, {
    code,
  });
};

export const getManageLinkProfile = async (id) => {
  return api.get(`/link-profiles/${encodeURIComponent(id)}/manage`);
};

export const updateLinkProfile = async (id, payload) => {
  const isFormData = payload instanceof FormData;
  return api.patch(`/link-profiles/${encodeURIComponent(id)}`, payload, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
  });
};

export const getLinkProfileButtons = async (id) => {
  return api.get(`/link-profiles/${encodeURIComponent(id)}/buttons`);
};

export const createLinkProfileButton = async (id, payload) => {
  return api.post(`/link-profiles/${encodeURIComponent(id)}/buttons`, payload);
};

export const updateLinkProfileButtons = async (id, payload) => {
  return api.patch(`/link-profiles/${encodeURIComponent(id)}/buttons`, payload);
};

export const reorderLinkProfileButtons = async (id, payload) => {
  return api.patch(
    `/link-profiles/${encodeURIComponent(id)}/buttons/reorder`,
    payload,
  );
};

export const updateLinkProfileButton = async (id, buttonId, payload) => {
  return api.patch(
    `/link-profiles/${encodeURIComponent(id)}/buttons/${encodeURIComponent(
      buttonId,
    )}`,
    payload,
  );
};

export const deleteLinkProfileButton = async (id, buttonId) => {
  return api.delete(
    `/link-profiles/${encodeURIComponent(id)}/buttons/${encodeURIComponent(
      buttonId,
    )}`,
  );
};

export const getLinkProfileHighlights = async (id) => {
  return api.get(`/link-profiles/${encodeURIComponent(id)}/highlights`);
};

export const uploadLinkProfileHighlight = async (id, formData) => {
  return api.post(
    `/link-profiles/${encodeURIComponent(id)}/highlights`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const deleteLinkProfileHighlight = async (id, highlightId) => {
  return api.delete(
    `/link-profiles/${encodeURIComponent(id)}/highlights/${encodeURIComponent(
      highlightId,
    )}`,
  );
};

export const reorderLinkProfileHighlights = async (id, payload) => {
  return api.patch(
    `/link-profiles/${encodeURIComponent(id)}/highlights/reorder`,
    payload,
  );
};

export const checkLinkProfileSlugAvailability = async (slug, signal) => {
  return api.get("/link-profiles/slug/check", { params: { slug }, signal });
};

export const createLinkProfile = async (payload) => {
  return api.post("/link-profiles", payload);
};

export const getMyLinkProfileOptions = async () => {
  return api.get("/link-profiles/me/options");
};

export const getLinkProfileNfcTags = async (id, params = {}) => {
  return api.get(`/link-profiles/${encodeURIComponent(id)}/nfc-tags`, {
    params,
  });
};

export const getLinkProfileUnassignedNfcTags = async (params = {}) => {
  return api.get(`/link-profiles/nfc-tags/unassigned`, { params });
};

export const assignLinkProfileNfcTag = async (id, tagId) => {
  return api.patch(`/link-profiles/${encodeURIComponent(id)}/nfc-tags/assign`, {
    tagId,
  });
};

export const updateLinkProfileNfcTagStatus = async (id, tagId, payload) => {
  return api.patch(
    `/link-profiles/${encodeURIComponent(id)}/nfc-tags/${encodeURIComponent(
      tagId,
    )}/status`,
    payload,
  );
};

export const reassignNfcTag = async (id, tagId, targetProfileId) => {
  return api.patch(
    `/link-profiles/${encodeURIComponent(id)}/nfc-tags/${encodeURIComponent(
      tagId,
    )}/reassign`,
    { targetProfileId },
  );
};

export const getAdminLinkProfiles = async (params = {}) => {
  return api.get("/admin/link-profiles", { params });
};

export const getAdminLinkProfile = async (id) => {
  return api.get(`/admin/link-profiles/${encodeURIComponent(id)}`);
};

export const updateAdminLinkProfile = async (id, payload) => {
  return api.patch(`/admin/link-profiles/${encodeURIComponent(id)}`, payload);
};

export const updateAdminLinkProfileStatus = async (id, payload) => {
  return api.patch(
    `/admin/link-profiles/${encodeURIComponent(id)}/status`,
    payload,
  );
};

export const updateAdminLinkProfileNfcTagsStatus = async (id, payload) => {
  return api.patch(
    `/admin/link-profiles/${encodeURIComponent(id)}/nfc-tags/status`,
    payload,
  );
};

export const getAdminNfcTags = async (params = {}) => {
  return api.get("/admin/link-profiles/nfc-tags", { params });
};

export const disableLinkProfile = async (id) => {
  return api.post(`/link-profiles/${encodeURIComponent(id)}/disable`);
};

export const enableLinkProfile = async (id) => {
  return api.post(`/link-profiles/${encodeURIComponent(id)}/enable`);
};

export const deleteLinkProfile = async (id) => {
  return api.delete(`/link-profiles/${encodeURIComponent(id)}`);
};

export const claimLinkProfileDirect = async (identifier, body = {}) => {
  return api.post(
    `/link-profiles/claim/${encodeURIComponent(identifier)}`,
    body,
  );
};
